<template>
    <div>
        <nav aria-label="breadcrumb" role="navigation">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" aria-current="page">{{currentType}}</li>
                <li v-if="currentMark" class="breadcrumb-item" aria-current="page">{{currentMark}}</li>
                <li v-if="currentCountry" class="breadcrumb-item" aria-current="page">{{currentCountry}}</li>
                <li v-if="currentFamily" class="breadcrumb-item" aria-current="page">{{currentFamily}}</li>
                <li v-if="currentModel" class="breadcrumb-item" aria-current="page">{{currentModel}}</li>
                <li v-if="currentModification" class="breadcrumb-item" aria-current="page">{{currentModification}}</li>
                <li v-if="currentGroup" class="breadcrumb-item" aria-current="page">{{currentGroup}}</li>
                <li v-if="currentSubGroup" class="breadcrumb-item" aria-current="page">{{currentSubGroup}}</li>
            </ol>
        </nav>
        <div class="row">
            <div class="col-3 mt-3">
                <el-select v-model="currentType" placeholder="Тип">
                    <el-option v-for="item in typeList"
                               :key="item.value"
                               :label="item.name"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-3 mt-3" v-if="currentType && markList.length > 0">
                <el-select v-model="currentMark" placeholder="Марка">
                    <el-option v-for="item in markList"
                               :key="item.value"
                               :label="item.name"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-3 mt-3" v-if="currentMark && countryList.length > 0">
                <el-select v-model="currentCountry" placeholder="Страна">
                    <el-option v-for="item in countryList"
                               :key="item.value"
                               :label="item.name"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-3 mt-3" v-if="currentCountry && familyList.length > 0">
                <el-select v-model="currentFamily" placeholder="Семейство">
                    <el-option v-for="item in familyList"
                               :key="item.value"
                               :label="item.name"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-3 mt-3" v-if="currentFamily && modelList.length > 0">
                <el-select v-model="currentModel" placeholder="Модель">
                    <el-option v-for="item in modelList"
                               :key="item.value"
                               :label="item.name"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-3 mt-3" v-if="currentModel && modificationList.length > 0">
                <el-select v-model="currentModification" placeholder="Модификация">
                    <el-option v-for="item in modificationList"
                               :key="item.value"
                               :label="item.name"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-3 mt-3" v-if="currentModification && groupList.length > 0">
                <el-select v-model="currentGroup" placeholder="Группа">
                    <el-option v-for="item in groupList"
                               :key="item.value"
                               :label="item.name"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-3 mt-3" v-if="currentGroup && subGroupList.length > 0">
                <el-select v-model="currentSubGroup" placeholder="Подгруппа">
                    <el-option v-for="item in subGroupList"
                               :key="item.value"
                               :label="item.name"
                               :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
  import FilterMixin from '../mixin/filter'

  export default {
    name: 'mercedes-filter',
    mixins: [FilterMixin],
    data () {
      return {
        dataCountry: {},
        dataFamily: {},
        dataModel: {},
        dataModification: {},
        dataGroup: {},
        dataSubGroup: {},

        currentCountry: '',
        currentFamily: '',
        currentModel: '',
        currentModification: '',
        currentGroup: '',
        currentSubGroup: ''
      }
    },
    computed: {
      countryList () {
        const dataList = this.dataCountry.countries
        return this.getListFromData(dataList, item => {
          return {
            name: item.name,
            value: item.short
          }
        })
      },
      familyList () {
        const dataList = this.dataFamily.families
        return this.getListFromData(dataList, item => {
          return {
            name: item.family,
            value: item.family
          }
        })
      },
      modelList () {
        const dataList = this.dataModel.models
        return this.getListFromData(dataList, item => {
          return {
            name: item.model_name,
            value: item.model
          }
        })
      },
      modificationList () {
        const dataList = this.dataModification.modifications
        return this.getListFromData(dataList, item => {
          return {
            name: item.modification,
            value: item.modification
          }
        })
      },
      groupList () {
        const dataList = this.dataGroup.groups
        return this.getListFromData(dataList, item => {
          return {
            name: item.name,
            value: item.group
          }
        })
      },
      subGroupList () {
        const dataList = this.dataSubGroup.subgroups
        return this.getListFromData(dataList, item => {
          return {
            name: item.name,
            value: item.subgroup
          }
        })
      }
    },
    watch: {
      currentCountry (value) {
        if (value !== '') {
          this.getData([this.currentType, this.currentMark, value])
        }
      },
      currentFamily (value) {
        if (value !== '') {
          this.getData([this.currentType, this.currentMark, this.currentCountry, value])
        }
      },
      currentModel (value) {
        if (value !== '') {
          this.getData([this.currentType, this.currentMark, this.currentCountry, this.currentFamily, value])
        }
      },
      currentModification (value) {
        if (value !== '') {
          this.getData([this.currentType, this.currentMark, this.currentCountry, this.currentFamily, this.currentModel, value])
        }
      },
      currentGroup (value) {
        if (value !== '') {
          this.getData([this.currentType, this.currentMark, this.currentCountry, this.currentFamily, this.currentModel, this.currentModification, value])
        }
      },
      currentSubGroup (value) {
        if (value !== '') {
          this.getData([this.currentType, this.currentMark, this.currentCountry, this.currentFamily, this.currentModel, this.currentModification, this.currentGroup, value])
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/autoCatalogFilter/components/Mercedes.vue